import * as Sentry from "@sentry/react";

interface SentryUser {
  id: string;
  username?: string;
  email?: string;
}

const isProduction = process.env.REACT_APP_ENVIRONMENT === "production";

const sentryDsn = process.env.REACT_APP_SENTRY_DNS || "";

if (window.location.hostname !== "localhost") {
  Sentry.init({
    dsn: sentryDsn,
    environment: process.env.REACT_APP_ENVIRONMENT,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false,
        networkDetailAllowUrls: [
          process.env.REACT_APP_ROUTE_API_URL,
          process.env.REACT_APP_GENERATOR_API_URL,
        ],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,

    // Session Replay
    replaysSessionSampleRate: isProduction ? 1 : 0.2, // This sets the sample rate at 100%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0,
  });

  window.onerror = (message, source, lineno, colno, error) => {
    Sentry.captureException(error || message);
  };

  window.onunhandledrejection = (event) => {
    Sentry.captureException(event.reason);
  };
}

export const setUserInSentry = (user: SentryUser) => {
  Sentry.setUser({
    id: user.id,
    username: user.username,
    email: user?.email,
  });
};

export const setTagInSentry = (tag: string, value: string) => {
  Sentry.setTag(tag, value);
};

export const captureException = (error: any, extra?: any) => {
  Sentry.captureException(error, {
    extra,
  });
};

export default Sentry;
